import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      text: 'SSL Secured',
      description: 'Your data is encrypted and protected'
    },
    {
      icon: 'Lock',
      text: 'Privacy Protected',
      description: 'GDPR compliant data handling'
    },
    {
      icon: 'CheckCircle',
      text: 'Trusted Platform',
      description: 'Secure authentication system'
    }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex items-center space-x-2 text-center sm:text-left justify-center sm:justify-start"
          >
            <div className="flex-shrink-0 w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
              <Icon name={feature?.icon} size={16} className="text-success" />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-medium text-foreground">{feature?.text}</p>
              <p className="text-xs text-muted-foreground hidden sm:block">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 text-center">
        <p className="text-xs text-muted-foreground">
          By signing in, you agree to our{' '}
          <button className="text-primary hover:text-primary/80 transition-warm">
            Terms of Service
          </button>
          {' '}and{' '}
          <button className="text-primary hover:text-primary/80 transition-warm">
            Privacy Policy
          </button>
        </p>
      </div>
    </div>
  );
};

export default SecurityBadges;